import React from 'react';

import ImageSkeletonIcon from '~/public/assets/images/svg/image-icon.svg';

function ImageLoader() {
  return (
    <div className={'flex h-full flex-col gap-3 min-h-[182px]'}>
      <div className="absolute inset-0 animate-wave bg-gradient-to-r from-transparent via-white/70 to-transparent"></div>
      <div className=" flex grow items-center justify-center overflow-hidden bg-silver-400">
        <ImageSkeletonIcon className="h-10 w-10 text-white" />
      </div>
    </div>
  );
}

export default ImageLoader;
